// @ts-check
import { attrConfig as wId } from './w-id.js';
import { attrConfig as wEdGrp } from './w-edGrp.js';
import { attrConfig as wEd } from './w-ed.js';
import { attrConfig as wColFirst } from './w-col-first.js';
import { attrConfig as wColLast } from './w-col-last.js';

/**
 * All valid attributes for the <w:permStart> element.
 * @type {import('@translator').AttrConfig[]}
 */
export default [wId, wEdGrp, wEd, wColFirst, wColLast];
